module.exports = __webpack_public_path__ + "img/MOBILE_Banner_Dados.b08a6ac8.png";